import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../utils/analytics';

/**
 * ScrollToTopOnRouteChange component
 * 
 * Automatically scrolls to the top of the page when the route changes.
 * This ensures users start at the top when navigating between pages.
 */
export const ScrollToTopOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle hash-based navigation (e.g., #pricing, #features)
    if (location.hash) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1));
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
          analytics.trackFeatureUsage('navigation', `scroll-to-${location.hash.slice(1)}`);
        }
      }, 100);
    } else {
      // Scroll to top when route changes (no hash)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // Use smooth scrolling for better UX
      });
    }

    // Track page navigation for analytics
    analytics.trackPageView(location.pathname + location.hash);
    
    // Also track the specific page name for better insights
    const pageName = location.pathname === '/' ? 'home' : location.pathname.slice(1);
    analytics.trackFeatureUsage('navigation', `visit-${pageName}`);

  }, [location.pathname, location.hash]); // Trigger when pathname or hash changes

  // This component doesn't render anything
  return null;
};
